/* eslint-disable @typescript-eslint/lines-between-class-members */
/* eslint-disable class-methods-use-this */

// import "./HeaderRow.css";

import {
  CellTemplate,
  Cell,
  Compatible,
  Uncertain,
  getCellProperty,
  keyCodes,
} from '@silevis/reactgrid';
import { BiFilter } from 'react-icons/bi';
import { Flex, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';

import { capitalizeFirstLetter } from 'utils/GlobalHelpers';

export interface FlagCell extends Cell {
  type: 'flag';
  text: string;
  rowId: string;
  property: string;
}
export class HeaderRow implements CellTemplate<FlagCell> {
  getCompatibleCell(uncertainCell: Uncertain<FlagCell>): Compatible<FlagCell> {
    const text = getCellProperty(uncertainCell, 'text', 'string');
    const value = Number.parseFloat(text);
    return { ...uncertainCell, text, value } as Compatible<FlagCell>;
  }

  handleKeyDown(
    cell: Compatible<FlagCell>,
    keyCode: number,
  ): { cell: Compatible<FlagCell>; enableEditMode: boolean } {
    if (keyCode === keyCodes.ENTER) {
      return { cell, enableEditMode: true };
    }
    return { cell, enableEditMode: false };
  }

  getClassName(cell: any) {
    const isValid = cell.validator ? cell.validator(cell.text) : true;
    const className = cell.className ?? '';
    return `${isValid ? 'valid' : 'invalid'} ${
      cell.placeholder && cell.text === '' ? 'placeholder' : ''
    } ${className}`;
  }
  render(cell: Compatible<FlagCell>) {
    return (
      <>
        {cell?.property === 'dimension' ? (
          <Flex align={'center'} justify={'space-between'} w={'100%'}>
            <p
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                maxWidth: '100%',
                textOverflow: 'ellipsis',
                paddingLeft: '3px',
              }}
            >
              {capitalizeFirstLetter(cell?.text)}
            </p>
            <Flex>
              <Menu strategy='fixed'>
                <MenuButton transition='all 0.2s'>
                  <BiFilter size={25} opacity={0.5} />
                </MenuButton>
                <MenuList>
                  <MenuItem>Download</MenuItem>
                  <MenuItem>Create a Copy</MenuItem>
                  <MenuItem>Mark as Draft</MenuItem>
                  <MenuItem>Delete</MenuItem>
                  <MenuItem>Attend a Workshop</MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          </Flex>
        ) : (
          <p
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              maxWidth: '100%',
              textOverflow: 'ellipsis',
              paddingLeft: '3px',
            }}
          >
            {capitalizeFirstLetter(cell?.text)}
          </p>
        )}
      </>
    );
  }
}
